import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';

import { types as imagesTypes, actions as imagesActions } from 'ducks/inventoryEnquiry/attachments/images';

import { callApi } from '../../utils';
import * as api from 'api/inventoryEnquiry/attachments/images';


function* fetch(action) {
  const { success, failure } = imagesActions.saga.fetch;
  yield callApi(
    call(api.fetch, action.data),
    success,
    failure
  )
}

export default function* rootSaga() {
  yield takeLatest(imagesTypes.fetch, fetch)
}